import React, { useState, useRef } from 'react';
import './AddFaceForm.css'

const AddFaceForm = ({onClose, onSubmit}) => {
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const image1Ref = useRef(null);
    const image2Ref = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        onSubmit(data);
        onClose();
    };
    const handleCaptureImage = (event, setImage) => {
        const file = event.target.files[0];
        const reader = new FileReader();
    
        reader.onload = (event) => {
          setImage(event.target.result);
        };
    
        if (file) {
          reader.readAsDataURL(file);
        }
      };

  return (
    <div className="popup">
      <div className="popup-content">
        <div className="close-button" onClick={onClose}>
          <span className="close-icon"></span>
        </div>
        <h2>Add Face</h2>
        <form onSubmit={handleSubmit}>
        <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" required />

          <label htmlFor="age">Age:</label>
          <input type="number" id="age" name="age" required />

          <label htmlFor="gender">Gender:</label>
          <select id="gender" name="gender" required>
            <option value="">Select gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>

          <label htmlFor="image1">Image 1:</label>
          <input
            type="file"
            id="image1"
            name="image1"
            accept="image/*"
            onChange={(e) => handleCaptureImage(e, setImage1)}
            ref={image1Ref}
            required
          />
          {image1 && (
            <img src={image1} alt="Error loading" className="captured-image" onClick={() => image1Ref.current.click()} />
          )}

          <label htmlFor="image2">Image 2:</label>
          <input
            type="file"
            id="image2"
            name="image2"
            accept="image/*"
            onChange={(e) => handleCaptureImage(e, setImage2)}
            ref={image2Ref}
            required
          />
          {image2 && (
            <img src={image2} alt="Error loading" className="captured-image" onClick={() => image2Ref.current.click()} />
          )}

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default AddFaceForm;
